import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { chairRentalShape } from '../shapes';
import Input from '../../../../common/input';
import Icon, { GLYPHS } from '../../../../common/icon';
import Select from '../../../../common/select';
import OwnerPaymentCard from '../../../../common/ownerPaymentCard/OwnerPaymentCardContainer';
import ChairRentalPayment from './ChairRentalPayment';
import { DAYS_OF_WEEK_OPTIONS } from '../../../constants';
import CurrencyInput from '../../../../common/currencyInput';
import { t } from '../../../../../modules/infra/i18n';

const ChairRentalDetails = ({
  chairRental,
  pristine,
  valid,
  submitForm,
  hasPaymentCard,
  card,
}) => (
  <div className="c-chair-rental-modal__details">
    <div className="c-separator" />
    <form onSubmit={submitForm}>
      <Input type="hidden" name="enabled" />
      <div className="o-flexbox u-p">
        <div>
          <div className="c-label-new">
            {t('barber:chair_rental.details.weekly_rent_amount')}
          </div>
          <CurrencyInput className="c-input c-input--white u-width-140" name="paymentAmount" />
        </div>
        <div>
          <div className="c-label-new">
            {t('barber:chair_rental.details.payment_day')}
            <Icon glyph={GLYPHS.autopay} size="micro" className="u-ml- u-mb--" />
          </div>
          <Select
            className="c-select"
            name="paymentDay"
            options={DAYS_OF_WEEK_OPTIONS}
            normalize={value => Number(value)}
          />
        </div>
      </div>
    </form>

    <div className="c-separator" />

    <div className="c-chair-rental-modal__payment u-p">
      <div className="c-label-new">
        {t('barber:chair_rental.details.payment_method')}
      </div>
      <OwnerPaymentCard
        buttonText={t('barber:chair_rental.details.add_card')}
        card={card}
      />
    </div>

    <div className="c-separator" />

    <div className="u-p">
      <div className="c-table-card" display-if={chairRental && chairRental.nextPayment}>
        <div className="c-table-card__head">
          <div className="c-table-card__cell u-2/10 u-pl0">
            <div className="c-label-new">{t('barber:chair_rental.list.next_payment')}</div>
          </div>
          <div className="c-table-card__cell u-3/10">
            <div className="c-label-new">{t('barber:chair_rental.details.method')}</div>
          </div>
          <div className="c-table-card__cell u-3/10">
            <div className="c-label-new">{t('barber:chair_rental.details.amount')}</div>
          </div>
          <div className="c-table-card__cell u-2/10">
            <div className="c-label-new">{t('barber:chair_rental.list.due_date')}</div>
          </div>
        </div>

        <ChairRentalPayment chairRentalPayment={chairRental.nextPayment} barberId={chairRental.barberId} card={card} />
      </div>

      <div className="c-table-card" display-if={chairRental && chairRental.overduePayments.length}>
        <div className="c-table-card__head">
          <div className="c-table-card__cell u-2/10 u-pl0">
            <div className="c-label-new">{t('barber:chair_rental.details.overdue_payments')}</div>
          </div>
          <div className="c-table-card__cell u-3/10" />
          <div className="c-table-card__cell u-3/10" />
          <div className="c-table-card__cell u-2/10" />
        </div>
        {chairRental.overduePayments.map(payment => (
          <ChairRentalPayment
            chairRentalPayment={payment}
            barberId={chairRental.barberId}
            key={`chair-rental-overdue-payment-${payment.id}`}
          />
        ))}
      </div>
    </div>

    <button
      className={classnames('c-chair-rental-modal__btn', {
        'is-disabled': pristine || !valid || !hasPaymentCard,
      })}
      type="button"
      onClick={submitForm}
    >
      {t('barber:chair_rental.details.save')}
    </button>
  </div>
);

ChairRentalDetails.propTypes = {
  chairRental: chairRentalShape.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  submitForm: PropTypes.func.isRequired,
  hasPaymentCard: PropTypes.bool.isRequired,
  card: PropTypes.shape({
    id: PropTypes.string,
    brand: PropTypes.string,
    last4: PropTypes.string,
    ownerId: PropTypes.string,
    ownerType: PropTypes.string,
  }),
};
ChairRentalDetails.defaultProps = {
  card: null,
};

export default ChairRentalDetails;
